import { orangeA100, blueGrey100, blueGrey600 } from '@/utils/constants'
import { positionBinding } from '@/graph_parts/binding'
import { validationNotEmpty } from '@/graph_parts/validation'
import * as go from 'gojs'
var $ = go.GraphObject.make

function createOperatorTemplate () {
  return $(go.Node, 'Spot',
    {
      selectable: false,
      selectionAdorned: false,
      locationSpot: go.Spot.TopLeft,
      isShadowed: true,
      shadowOffset: new go.Point(0, -3),
      shadowColor: blueGrey100,
      isAnimated: false
    },
    positionBinding(),
    new go.Binding('opacity', '', x => !x.isParentExcludedInQuery ? 1 : 0.4),
    $(go.Panel, 'Auto',
      $(go.Shape, 'RoundedRectangle',
        {
          fill: 'white',
          stroke: blueGrey600,
          strokeWidth: 1,
          parameter1: 10,
          margin: 0,
          shadowVisible: true
        },
        new go.Binding('fill', '', i => { return i.data.isBeingEdited ? orangeA100 : 'white' }).ofObject()
      ),
      $(go.TextBlock,
        {
          margin: 0, // new go.Margin(1, 3, 1, 3),
          isMultiline: false,
          font: 'normal 14px Roboto',
          stroke: blueGrey600,
          shadowVisible: false,
          editable: true,
          textValidation: validationNotEmpty,
          textEdited: function (textBlock, oldText, newText) {
            const i = textBlock.part.containingGroup.part.memberParts.iterator
            while (i.next()) {
              if (i.value.part.data.isOperator) {
                textBlock.diagram.model.setDataProperty(i.value.part.data, 'text', newText)
              }
            }
            textBlock.diagram.model.setDataProperty(textBlock.part.containingGroup.part.data, 'operator', newText)
            textBlock.part.invalidateLayout()
            if (textBlock.part.containingGroup) {
              textBlock.part.containingGroup.invalidateLayout()
            }
          }
        },
        new go.Binding('text', 'text')
      )
    ),
    // This is here to make the operator the same height as a node
    $(go.Panel, 'Auto',
      { alignment: new go.Spot(1, 0, 8, 12), alignmentFocus: go.Spot.BottomRight },
      $(go.Shape,
        { figure: 'Circle', fill: 'transparent', strokeWidth: 1, stroke: 'transparent', parameter1: 5 }
      ),
      $(go.TextBlock,
        {
          isMultiline: false,
          font: 'bold 13px',
          stroke: 'white',
          textAlign: 'center'
        }
      )
    )
  )
}

export { createOperatorTemplate }



// WEBPACK FOOTER //
// ./src/graph_parts/operator_template.js